var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServiceTravelCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33268 0.335938C1.86202 0.335938 0.666016 1.53194 0.666016 3.0026V19.0026C0.666016 20.4733 1.86202 21.6693 3.33268 21.6693H24.666C26.1367 21.6693 27.3327 20.4733 27.3327 19.0026V3.0026C27.3327 1.53194 26.1367 0.335938 24.666 0.335938H3.33268ZM7.33268 5.66927H9.99935C10.7353 5.66927 11.3327 6.2666 11.3327 7.0026V8.33594H13.3327C13.7007 8.33594 13.9993 8.6346 13.9993 9.0026V15.6693C13.9993 16.0373 13.7007 16.3359 13.3327 16.3359H3.99935C3.63135 16.3359 3.33268 16.0373 3.33268 15.6693V9.0026C3.33268 8.6346 3.63135 8.33594 3.99935 8.33594H5.99935V7.0026C5.99935 6.2666 6.59668 5.66927 7.33268 5.66927ZM7.33268 7.0026V8.33594H9.99935V7.0026H7.33268ZM17.9993 13.6693C18.7353 13.6693 19.3327 14.2666 19.3327 15.0026C19.3327 15.7386 18.7353 16.3359 17.9993 16.3359C17.2633 16.3359 16.666 15.7386 16.666 15.0026C16.666 14.2666 17.2633 13.6693 17.9993 13.6693ZM23.3327 13.6693C24.0687 13.6693 24.666 14.2666 24.666 15.0026C24.666 15.7386 24.0687 16.3359 23.3327 16.3359C22.5967 16.3359 21.9993 15.7386 21.9993 15.0026C21.9993 14.2666 22.5967 13.6693 23.3327 13.6693Z",
    fill: "#0044c6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceTravelCard);
export default __webpack_public_path__ + "static/media/serviceTravelCard.20307c182b9d8c3108f858ef9685bd5e.svg";
export { ForwardRef as ReactComponent };